import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action, indexPurchaseRequest) => {
    let body: "";

    body = data.map((register, index) => {

            return (
                <tr key={index}>
                    <td >{register.CardCode || ""}</td>
                    <td className="overflow-visible"
                                            style={{textAlign: 'left', maxWidth: 800}}>
                                            {register.CardName || ""}</td>
                    <td style={{textAlign:"center"}}>
                        <button type="button" className="btn btn-sm"
                                onClick={() => action({index},{indexPurchaseRequest})}
                                style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                            <i className="fas fa-check"></i>  
                        </button>
                    </td>
                </tr>
            )
    })

    return body;
};

const renderTable = (headers, data, action, indexPurchaseRequest) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow "></td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, indexPurchaseRequest);

    let table = "";

    table = 
    // className="table-wrapper-scroll-y my-custom-scrollbar"
    <div className="table-wrapper-scroll-y my-custom-scrollbar">
        <table id="dataTableCreate" className="display" style={{width: '100%',overflow:'auto'}}>
            <thead className="table-header ">
            {header}
            </thead>
            <tbody>
            {body}
            </tbody>
        </table>
    </div>;

    return table;

};

export const renderTablePartnerModal = (headers, data, action, indexPurchaseRequest) => {

    return renderTable(headers, data, action, indexPurchaseRequest);

}
